// extracted by mini-css-extract-plugin
export default {"nocalcIcon":"g3Fy4"};